import { Controller } from '@hotwired/stimulus'

import '../../../css/log/log.scss'
import 'jquery-ui-sortable-npm'
import 'semantic-ui-checkbox/checkbox.min'
import 'semantic-ui-dropdown/dropdown.min'
import 'semantic-ui-dropdown/dropdown.min.css'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'
import createFieldRule from "../../modules/validation/validation";

export default class extends Controller {
  static values = {
    integrationVendor: String,
    numberOfDays: { type: Number, default: 0 },
  }

  static targets = [
    'flowRates', 'flowRatesContainer',
    'integrationDropdown', 'singleDayEventConfig', 'multiDayEventConfig',
    'pollingStartDropdown', 'pollingEndDropdown', 'timingDropdown',
  ]

  get logTimingsTab() {
    return this.application.getControllerForElementAndIdentifier(document.querySelector('[data-controller="log-timings-tab"]'), 'log-timings-tab')
  }

  get flowRatePrototype() {
    return document.getElementById('flow-rate-prototype').dataset.prototype
  }

  connect() {
    this.numberOfDaysValue = this.logTimingsTab.numberOfDays ?? 0
    if (this.hasFlowRatesContainerTarget) {
      this.observeNumberOfDays()
    }

    $(this.integrationDropdownTarget).dropdown({
      clearable: true,
      forceSelection: false,
      onChange: (value) =>  {
        if (!this.hasFlowRatesContainerTarget) {
          return
        }

        if (!value) {
          this.removeFlowRates()
          this.hideFlowRates()
        } else {
          if (this.numberOfDaysValue > 0) {
            this.addFlowRates()
            this.showFlowRates()
          }
        }
      },
    })

    $(this.element.querySelectorAll('.startTiming, .endTiming')).dropdown({
      clearable: true,
      forceSelection: false,
      message: {
        noResults: 'Please setup timings to configure poll time'
      }
    })
    this.updateTimingOptions()

    document.addEventListener('timings:timing:added', this.addToDropdowns.bind(this));
    document.addEventListener('timings:timing:removed', this.removeFromDropdowns.bind(this));
    document.addEventListener('timings:isApplyToAllDays', this.updateTimingOptions.bind(this));
  }

  addToDropdowns(event) {
    this.element.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
      if (event.detail.isApplyToAllDays || event.detail.day === timing.closest('.flowRate').dataset.day) {
        const selectElement = timing.querySelector('select');
        const optionExists = Array.from(selectElement.options).some(option => option.value === event.detail.timingId);

        if (!optionExists) {
          selectElement.append(new Option(event.detail.timingName, event.detail.timingId));
        }
      }
    })
  }

  removeFromDropdowns(event) {
    this.element.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
      if (event.detail.isApplyToAllDays || event.detail.day === timing.closest('.flowRate').dataset.day) {
        if ($(timing).dropdown('get value') === event.detail.timingId) {
          $(timing).dropdown('clear')
        }

        timing.querySelector('select').querySelector(`option[value="${event.detail.timingId}"]`).remove();
      }
    })
  }

  hideFlowRates() {
    this.flowRatesContainerTarget.classList.add('d-none')
  }

  showFlowRates() {
    this.flowRatesContainerTarget.classList.remove('d-none')
  }

  removeFlowRates() {
    this.flowRatesTarget.innerHTML = ''
  }

  updateTimingOptions() {
    this.element.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
      Array.from(timing.querySelector('select').options).forEach(option => {
        if (option.value !== '') {
          option.remove();
        }
      })

      if (this.numberOfDaysValue > 1 && document.querySelector('#applyTimingsToAllDaysInput').checked) {
        document.querySelectorAll('.timing-group[data-day="0"] .log-event-select').forEach((select) => {
          if ($(select).dropdown('get value') !== '') {
            timing.querySelector('select').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
          }
        })
      } else {
        for (let i = 0; i < this.numberOfDaysValue; i++) {
          document.querySelectorAll('.timing-group[data-day="' + i + '"] .log-event-select').forEach((select) => {
            if ($(select).dropdown('get value') !== '') {
              timing.querySelector('select').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
            }
          })
        }
      }

      const selectedValue = $(timing).dropdown('get value');
      const optionExists = Array.from(timing.querySelector('select').options).some(option => option.value === selectedValue);
      if (!optionExists) {
        $(timing).dropdown('clear');
      }
    })
  }

  addFlowRates() {
    this.numberOfDaysValue = this.logTimingsTab.numberOfDays
    for (let i = 0; i < this.numberOfDaysValue; i++) {
      const newForm = this.flowRatePrototype.replace(/__name__/g, i)
      const div = document.createElement('div')
      div.innerHTML = newForm

      div.firstElementChild.dataset.day = i
      const dayLabel = div.querySelector('.day-label')
      if (dayLabel) {
        dayLabel.textContent = `Day ${i + 1}`
      }

      const dayInput = div.querySelector('input[name$="[day]"]')
      if (dayInput) {
        dayInput.value = i
      }

      const integrationInput = div.querySelector('select[name$="[integration]"]')
      if (integrationInput) {
        integrationInput.value = this.integrationDropdownTarget.value
      }

      ['.startTiming', '.endTiming'].forEach(selector => {
        Array.from(div.querySelector(selector).options).forEach(option => {
          if (option.value !== '') {
            option.remove();
          }
        })
      })

      if (this.numberOfDaysValue > 1 && document.querySelector('#applyTimingsToAllDaysInput').checked) {
        document.querySelectorAll('.timing-group[data-day="0"] .log-event-select').forEach((select) => {
          if ($(select).dropdown('get value') !== '') {
            div.querySelector('.startTiming').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
            div.querySelector('.endTiming').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
          }
        })
      } else {
        document.querySelectorAll('.timing-group[data-day="' + i + '"] .log-event-select').forEach((select) => {
          if ($(select).dropdown('get value') !== '') {
            div.querySelector('.startTiming').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
            div.querySelector('.endTiming').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')));
          }
        })
      }

      $(div.querySelector('.startTiming')).dropdown({
        clearable: true,
        forceSelection: false,
        message: {
          noResults: 'Please setup timings to configure poll time'
        }
      })

      $(div.querySelector('.endTiming')).dropdown({
        clearable: true,
        forceSelection: false,
        message: {
          noResults: 'Please setup timings to configure poll time'
        }
      })

      this.flowRatesTarget.appendChild(div)

      const newFormRule = {
        [`tickets_sold_${i}`]: createFieldRule(`log_flowRates_${i}_ticketsSold`, 'empty', 'Please enter venue capacity if tickets sold is unknown')
      };
      const currentFormRules = $('#form').form('setting', 'fields');
      $('#form').form('destroy');
      $('#form').form({ fields: { ...currentFormRules, ...newFormRule }, inline: true });
    }
  }

  observeNumberOfDays() {
    const onDatasetChange = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-number-of-days') {
          this.numberOfDaysValue = this.logTimingsTab.numberOfDays;
          if ($(this.integrationDropdownTarget).dropdown('get value')) {
            this.removeFlowRates()
            this.addFlowRates()
            this.showFlowRates()
          }
        }
      }
    }

    const observerOptions = { attributes: true }
    const observer = new MutationObserver(onDatasetChange)
    observer.observe(this.logTimingsTab.element, observerOptions)
  }
}
